module.exports = __webpack_public_path__ + "img/paypal.2f89b5aa.svg";